module.exports = __webpack_public_path__ + "img/stock7.279aab38.png";